module.exports = __webpack_public_path__ + "static/media/arq.ff139183.jpeg";